import { createContext, useContext, useState } from "react";

type ScrollContextValue = {
  scrolled: boolean;
  setScrolled: (value: boolean) => void;
};

const ScrollContext = createContext<ScrollContextValue | undefined>(undefined);

export function AppScrollProvider({ children }: { children: React.ReactNode }) {
  const [scrolled, setScrolled] = useState(false);

  return (
    <ScrollContext.Provider value={{ scrolled, setScrolled }}>
      {children}
    </ScrollContext.Provider>
  );
}

export function useAppScroll(): ScrollContextValue {
  const context = useContext(ScrollContext);
  if (!context) {
    throw new Error("useAppScroll must be used within an AppScrollProvider");
  }
  return context;
}
